import Home from '@/pages/home';
import PreviewPage from '@/pages/preview';
import ProductCreation from '@/pages/v1/product-creation';
import ProductsPage from '@/pages/v1/products';
import { BrowserRouter, Routes as ReactRoutes, Route } from 'react-router-dom';
import DashboardLayout from './components/app/dashboard-layout';
import NewProductPage from './pages/v1/products/new';

export default function Routes() {
  return (
    <BrowserRouter>
      <ReactRoutes>
        <Route path="/" element={<Home />} />
        <Route
          path="/*"
          element={
            <DashboardLayout>
              <ReactRoutes>
                <Route path="/v1/products" element={<ProductsPage />} />
              </ReactRoutes>
            </DashboardLayout>
          }
        />
        <Route path="/v1/products/new" element={<ProductCreation />} />
        <Route path="/v1/product-creation" element={<NewProductPage />} />
        <Route path="/preview" element={<PreviewPage />} />
      </ReactRoutes>
    </BrowserRouter>
  );
}
